import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowLeft } from 'lucide-react';
import LegalComplianceStamp from '../../components/legal/LegalComplianceStamp';

/**
 * Version enrichie basée sur le dossier juridique PADAID.
 * Les zones [ ] doivent être finalisées (déductibilité fiscale, médiation, etc.).
 */
const CGU = () => {
  return (
    <div className="min-h-screen">
      <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <Link to="/" className="inline-flex items-center text-muted-foreground hover:text-primary mb-6" data-testid="legal-back-link">
          <ArrowLeft className="mr-2 h-4 w-4" /> Retour à l'accueil
        </Link>
        <h1 className="text-3xl font-bold mb-2">Conditions générales d'utilisation</h1>
        <p className="text-sm text-muted-foreground mb-8">Dernière mise à jour : juillet 2026</p>

        <div className="prose prose-sm max-w-none space-y-6 text-muted-foreground">
          <section>
            <h2 className="text-xl font-semibold text-foreground mb-2">Objet</h2>
            <p>Les présentes conditions générales d'utilisation (CGU) régissent l'accès et l'utilisation du site PADAID par tout visiteur, membre ou adhérent.</p>
          </section>
          <section>
            <h2 className="text-xl font-semibold text-foreground mb-2">Accès au site</h2>
            <p>Le site est accessible gratuitement à tout utilisateur disposant d'un accès à Internet. Certaines fonctionnalités (espace membre, boutique, dons, messagerie) nécessitent la création d'un compte.</p>
          </section>
          <section>
            <h2 className="text-xl font-semibold text-foreground mb-2">Compte utilisateur</h2>
            <p>L'utilisateur s'engage à fournir des informations exactes lors de son inscription et à préserver la confidentialité de ses identifiants. Toute activité réalisée depuis un compte est réputée effectuée par son titulaire, sauf preuve contraire. La création d'un compte par un mineur requiert le consentement du ou des titulaires de l'autorité parentale.</p>
          </section>
          <section>
            <h2 className="text-xl font-semibold text-foreground mb-2">Comportement des utilisateurs et messagerie</h2>
            <p>Les utilisateurs s'engagent à ne pas publier de contenu illicite, diffamatoire, injurieux, haineux ou contraire à l'objet de l'association, et à respecter les autres membres de la communauté PADAID. La messagerie interne comporte des mécanismes de signalement et de blocage. À des fins de sécurité et de modération, les messages peuvent être conservés et, en cas de signalement ou d'incident, consultés par les responsables habilités de l'association. PADAID se réserve le droit de suspendre ou de supprimer tout compte contrevenant.</p>
          </section>
          <section>
            <h2 className="text-xl font-semibold text-foreground mb-2">Dons et paiements</h2>
            <p>Les dons et achats effectués sur le site sont traités via un prestataire de paiement sécurisé (Stripe). Les données de paiement ne sont jamais stockées en clair par l'association.</p>
            <p>PADAID étant un organisme d'intérêt général, les dons consentis à l'association peuvent ouvrir droit à une réduction d'impôt dans les conditions prévues à l'article 200 du Code général des impôts (pour les particuliers) et à l'article 238 bis du même code (pour les entreprises). <strong>Un reçu fiscal est délivré au donateur</strong> afin de lui permettre de bénéficier de cette réduction d'impôt.</p>
          </section>
          <section>
            <h2 className="text-xl font-semibold text-foreground mb-2">Propriété intellectuelle</h2>
            <p>Les contenus publiés par les utilisateurs restent sous leur responsabilité. Les contenus du site (textes, images, logo, vidéos) sont, sauf mention contraire, la propriété de PADAID et protégés par le droit d'auteur.</p>
          </section>
          <section>
            <h2 className="text-xl font-semibold text-foreground mb-2">Modification des CGU</h2>
            <p>PADAID se réserve le droit de modifier les présentes CGU à tout moment. Les utilisateurs seront informés de toute modification substantielle.</p>
          </section>
          <section>
            <h2 className="text-xl font-semibold text-foreground mb-2">Droit applicable</h2>
            <p>Les présentes CGU sont soumises au droit français. Tout litige relève de la compétence des tribunaux français. <em>[Une clause de médiation de la consommation sera ajoutée si la boutique vend des biens à des consommateurs.]</em></p>
          </section>
          <LegalComplianceStamp />
        </div>
      </div>
    </div>
  );
};

export default CGU;
